import { formatDate } from '@reach/web-ui/utils';

const SECONDS_PER_MINUTE = 60;
const SECONDS_PER_HOUR = 60 * SECONDS_PER_MINUTE;
const SECONDS_PER_DAY = 24 * SECONDS_PER_HOUR;
const SECONDS_PER_WEEK = 7 * SECONDS_PER_DAY;

export function formatLastCall(date: string): string {
  const elapsedSeconds = Math.floor((Date.now() - new Date(date).getTime()) / 1000);
  if (elapsedSeconds < SECONDS_PER_MINUTE) return 'Just now';
  if (elapsedSeconds < SECONDS_PER_HOUR)
    return `${Math.floor(elapsedSeconds / SECONDS_PER_MINUTE)}m ago`;
  if (elapsedSeconds < SECONDS_PER_DAY) return `${Math.floor(elapsedSeconds / SECONDS_PER_HOUR)}h ago`;
  if (elapsedSeconds < SECONDS_PER_WEEK) return `${Math.floor(elapsedSeconds / SECONDS_PER_DAY)}d ago`;
  return formatDate(date);
}
